<script lang="ts">
  import { DollarSign } from "@lucide/svelte"

  import { Button } from "@/components/ui/button"
  import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
  } from "@/components/ui/card"
  import type { TaskTemplate } from "@/types"
  import { formatTaskLimit } from "@/utils"

  interface Props {
    taskTemplate: TaskTemplate
    onClaim?: () => void
  }

  let { taskTemplate, onClaim }: Props = $props()
</script>

<Card>
  <CardHeader>
    <CardTitle>{taskTemplate.name}</CardTitle>
    {#if taskTemplate.description}
      <CardDescription>{taskTemplate.description}</CardDescription>
    {/if}
  </CardHeader>
  <CardContent class="space-y-2">
    {#if taskTemplate.wage}
      <div class="flex items-center gap-2 text-sm font-medium">
        <DollarSign class="h-4 w-4" />
        <span>{Number.parseFloat(taskTemplate.wage).toFixed(2)}</span>
      </div>
    {/if}
    {#if formatTaskLimit(taskTemplate.min_instances, taskTemplate.max_instances)}
      <div class="text-sm text-muted-foreground">
        {formatTaskLimit(taskTemplate.min_instances, taskTemplate.max_instances)}
      </div>
    {/if}
  </CardContent>
  {#if onClaim}
    <CardFooter>
      <Button onclick={onClaim} class="w-full">Claim & Complete</Button>
    </CardFooter>
  {/if}
</Card>
